module.exports = __webpack_public_path__ + "img/AIDLT_Logo.5d2a1c33.png";